<template>
  <div style="height: 100%; overflow: hidden">
    <div class="top">
      <!-- <img
        src="../../img/qpxq/return.png"
        alt=""
        class="return"
        @click="gosy()"
      /> -->
      <div class="bt">气瓶详情</div>
    </div>
    <div v-if="this.flag" style="margin-top: 1vw">
      <div
        style="
          text-align: center;
          height: 12vw;
          display: flex;
          justify-content: center;
          align-items: center;
        "
      >
        <img
          src="../../img/qpxq/success.png"
          alt=""
          style="width: 8vw; height: 8vw"
        />
        <div v-if="info" class="zt1">成功! 已找到{{ info.qptm }}气瓶资料</div>
      </div>
    </div>
    <div
      v-if="this.flag"
      style="
        width: 84vw;
        margin-left: 8vw;
        font-size: 4vw;
        overflow-y: auto;
        height: 86%;
      "
    >
      <table>
        <tr>
          <td>燃气企业:{{ info.rqqy }}</td>
        </tr>
        <tr>
          <td>充装单位:{{ info.czdw }}</td>
        </tr>
        <tr>
          <td>供应站点:{{ info.gyzd }}</td>
        </tr>
        <tr>
          <td>产品名称:{{ info.cpmc }}</td>
        </tr>
        <tr>
          <td>出厂编号:{{ info.ccbh }}</td>
        </tr>
        <tr>
          <td>充装介质:{{ info.qzjz }}</td>
        </tr>
        <tr>
          <td>气瓶条码: {{ info.qptm }}</td>
        </tr>
        <tr>
          <td>气瓶型号:{{ info.qpxh }}</td>
        </tr>
        <tr>
          <td>制造单位:{{ info.zzdw }}</td>
        </tr>
        <tr>
          <td>生产日期:{{ info.scrq }}</td>
        </tr>
        <tr>
          <td>报废日期:{{ info.bfrq }}</td>
        </tr>
        <tr>
          <td>上检日期:{{ info.sjrq }}</td>
        </tr>
        <tr>
          <td>下检日期:{{ info.xjrq }}</td>
        </tr>
        <tr>
          <td>充装时间:{{ info.czsj }}</td>
        </tr>
        <tr>
          <td>配送人员:{{ info.psry + " " + info.tel }}</td>
        </tr>
        <tr>
          <td>配送时间:{{ info.pssj }}</td>
        </tr>
        <tr>
          <td>
            购气客户:{{ info.gqkh }} &nbsp;&nbsp;<span v-if="info.gqkh!=''" class="ysm">已实名</span>
          </td>
        </tr>
        <tr>
          <td>购气地址:{{ info.gqdz }}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import { getCylindersDetail } from "../../api/ZghApi/ZghAx";
export default {
  data() {
    return {
      bar_code: "",
      info: "",
      flag: false,
    };
  },
  components: {},
  created() {
    if (this.$route.query.b != "") {
      let params = {
        bar_code: this.$route.query.b,
      };
      getCylindersDetail(params).then((res) => {
        if (res.info != null && Object.keys(res.info).length != 0) {
          this.flag = true;
          this.info = res.info;
        } else {
          this.$dialog
            .alert({
              message: "未检测到该气瓶信息，请重试！",
            })
            .then(() => {
              // this.$router.push({ name: "ypscan" });
            });
          // this.$toast("识别失败，请重试！");
        }
      });
    }
  },
  destroyed() {},
  computed: {},
  mounted() {},
  methods: {
    gosy() {
      this.$router.push({ name: "Home" });
    },
  },
};
</script>
<style scoped>
.bt {
  position: absolute;
  left: 25vw;
  top: 4vw;
  width: 50vw;
  text-align: center;
  font-size: 4vw;
  font-weight: 600;
}
.zt1 {
  font-size: 4vw;
  font-weight: 500;
}
table,
td,
th {
  border: 1px solid black;
  height: 10vw;
  padding-left: 3vw;
}

table {
  border-collapse: collapse;
  width: 100%;
}

th {
  height: 70px;
}
.top {
  height: 12vw;
  width: 100vw;
  background-color: rgb(245, 247, 251);
  position: relative;
}
.return {
  width: 5vw;
  margin-top: 1.8vw;
  margin-left: 4vw;
}
.ysm {
  font-size: 3.5vw;
  padding: 4px;
  border: 1px solid;
  color: rgb(54, 119, 254);
}
</style>



// WEBPACK FOOTER //
// src/views/Home/query.vue